import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchContactLabours() {
  try {
    const { data } = yield call(api.get, {
      route: `SocialDV/GetSociaDVByFactoryId/1`,
    });
    console.log(data);
    const contactLabours = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setContactLabours({ contactLabours }));
  } catch (err) {
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_CONTACT_LABOURS, fetchContactLabours),
  ]);
}
